import { Box } from "@chakra-ui/react";

type PlaybackButtonProps = {
  isPlaying: boolean;
  onToggle: () => void;
  // What plays, for the button's label.
  subject?: string;
};

export const PlaybackButton = ({ isPlaying, onToggle, subject = "video" }: PlaybackButtonProps) => (
  <Box
    as="button"
    type="button"
    aria-label={isPlaying ? `Pause ${subject}` : `Play ${subject}`}
    onClick={onToggle}
    position="absolute"
    top="14px"
    right="14px"
    w="44px"
    h="44px"
    display="grid"
    placeItems="center"
    borderRadius="full"
    bg="rgba(10, 10, 10, 0.55)"
    color="#fff"
    fontSize="0.8rem"
    lineHeight={1}
    transitionProperty="background-color"
    transitionDuration="0.25s"
    transitionTimingFunction="brand"
    _hover={{ bg: "brand.600" }}
  >
    <Box as="span" aria-hidden="true">
      {isPlaying ? "❚❚" : "▶"}
    </Box>
  </Box>
);
